import { Animate } from "../animate";
import { useState } from "react";
import { QUICK_LOAN_INTEREST_RATE } from "../../constants";

function formatNGN(amount, decimals = 0) {
  return new Intl.NumberFormat("en-NG", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);
}

const interestRate = QUICK_LOAN_INTEREST_RATE / 100;
function interest(principal, tenure) {
  return ((interestRate * 12) / 365) * principal * tenure;
}

export const LoanSection = () => {
  const [duration, setDuration] = useState(11);
  const [loanAmount, setLoaAmount] = useState(formatNGN(1000000));

  const handleLoanAmountChange = (ev) => {
    setLoaAmount(formatNGN(ev.target.value.replace(/,/g, "")));
  };

  return (
    <section
      id="loans"
      className="w-full py-[56px] lg:py-[80px]"
      style={{ backgroundColor: "#E8F0ED" }}
    >
      <div className="max-width flex flex-col gap-[56px]">
        <Animate animation="fade-down">
          <div className="gap-10 flex flex-col lg:flex-row justify-between items-stretch ">
            <div className="w-full flex flex-col justify-center lg:max-w-[554px]">
              <h2 className="text-deep-primary font-medium text-[36px] leading-[40px] sm:text-[48px] sm:leading-[52px] lg:text-[64px] tracking-[-0.02em] lg:leading-[60px]">
                Access Quick Loans
              </h2>

              <p className="mt-6 text-base lg:text-lg font-medium text-grey-800">
                Get instant access to funds with competitive rates and flexible
                repayment terms.
                {/* Whether it's for personal needs MyCardGlobal
                has you covered. */}
              </p>

              {/* //////////////// */}

              <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-0 lg:mt-[88px] lg:flex lg:w-full lg:max-w-fit lg:gap-6">
                <div>
                  <p className="text-grey-600 text-xs lg:text-sm font-medium mb-2">
                    LOAN AMOUNT
                  </p>

                  <p>
                    <span className="text-primary font-bold text-2xl lg:text-[32px]">
                      10K - 5M
                    </span>
                  </p>
                </div>

                <div className="h-px w-full bg-grey-300 sm:h-auto sm:w-px"></div>

                <div className="">
                  <p className="text-grey-600 text-xs lg:text-sm font-medium mb-2">
                    DURATION
                  </p>

                  <p>
                    <span className="text-primary font-bold text-2xl lg:text-[32px]">
                      1 - 24
                    </span>
                    <span className="pb-[10px] text-grey-900 font-medium text-sm md:text-base">
                      {"  "}
                      months
                    </span>
                  </p>
                </div>

                <div className="h-px w-full bg-grey-300 sm:h-auto sm:w-px"></div>

                <div className="">
                  <p className="text-grey-600 text-xs lg:text-sm font-medium mb-2">
                    INTEREST RATE
                  </p>

                  <p>
                    <span className="text-primary font-bold text-2xl lg:text-[32px]">
                      {QUICK_LOAN_INTEREST_RATE}%
                    </span>
                    <span className="pb-[10px] text-grey-900 font-medium text-sm md:text-base">
                      {"  "}
                      per month
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="flex w-full max-w-[679px] flex-col gap-10 overflow-hidden bg-transparent">
              <div className="flex flex-col gap-8">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-8">
                  <label
                    htmlFor="loan-amount"
                    className="text-[24px] font-bold leading-8 text-deep-primary"
                  >
                    How much would you like to borrow?
                  </label>
                  <div className="flex items-center gap-2.5 text-[24px] leading-6 text-[#667085]">
                    <span>₦</span>
                    <div className="flex h-12 w-full shrink-0 items-center overflow-hidden rounded-lg border border-[rgba(0,30,81,0.15)] bg-[#FEFEFF] px-[15px] sm:w-[127px]">
                      <input
                        id="loan-amount"
                        type="text"
                        value={loanAmount}
                        onChange={handleLoanAmountChange}
                        aria-label="Loan amount"
                        className="w-full bg-transparent text-base leading-6 text-[rgba(0,30,81,0.45)] outline-none"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:gap-[35px]">
                  <label
                    htmlFor="loan-duration"
                    className="shrink-0 text-[24px] font-bold leading-8 text-deep-primary"
                  >
                    Loan Duration:
                  </label>
                  <div className="flex min-w-0 flex-1 flex-col gap-6 sm:flex-row sm:items-center">
                    <div className="min-w-0 w-full sm:w-[308px] sm:shrink-0">
                      <div className="flex justify-between text-sm leading-5 text-[#667085]">
                        <span>0</span>
                        <span>6</span>
                        <span>12</span>
                        <span>18</span>
                        <span>24</span>
                      </div>
                      <input
                        id="loan-duration"
                        type="range"
                        min="0"
                        max="24"
                        value={duration}
                        onChange={(event) =>
                          setDuration(Number(event.target.value))
                        }
                        aria-label="Loan duration in months"
                        className="loan-duration-slider w-full cursor-pointer"
                        style={{ "--duration": duration }}
                      />
                    </div>
                    <div className="flex items-center gap-2.5 text-[24px] leading-6 text-[#667085]">
                      <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-lg border border-[rgba(0,30,81,0.15)] bg-[#FEFEFF] text-base text-[rgba(0,30,81,0.45)]">
                        {duration}
                      </span>
                      <span>Months</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-8">
                  <p className="shrink-0 text-[24px] font-bold leading-8 text-deep-primary">
                    Interest Rate:
                  </p>
                  <p className="text-[24px] leading-8 text-[#667085]">
                    {QUICK_LOAN_INTEREST_RATE}% Per Month
                  </p>
                </div>

                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-8">
                  <p className="shrink-0 text-[24px] font-bold leading-8 text-deep-primary">
                    Payment Frequency:
                  </p>
                  <p className="text-[24px] leading-8 text-[#667085]">
                    Monthly
                  </p>
                </div>
              </div>

              <div className="flex h-[168px] items-center overflow-hidden rounded-[16px] bg-[#269296] px-6 text-[24px] leading-10 text-white">
                <p>
                  For a <strong className="font-black">₦{loanAmount}</strong>{" "}
                  loan at{" "}
                  <strong className="font-black">{interestRate * 100}%</strong>{" "}
                  interest rate per month over{" "}
                  <strong className="font-black">{duration} months</strong>{" "}
                  period, the estimated interest is{" "}
                  <strong className="font-black">
                    ₦{formatNGN(
                      interest(
                        Number(loanAmount.replace(/,/g, "")),
                        Number(duration) * 30,
                      ),
                      2,
                    )}
                  </strong>{" "}
                  Total repayment is{" "}
                  <strong className="font-black">
                    ₦
                    {formatNGN(
                      interest(
                        Number(loanAmount.replace(/,/g, "")),
                        Number(duration) * 30,
                      ) + Number(loanAmount.replace(/,/g, "")),
                      2,
                    )}
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </Animate>
      </div>
    </section>
  );
};
